/**
 * Passenger Service
 * Wraps the Customer Config endpoints documented in api-docs/document (2).json:
 *   GET /v1/customers/config/passenger-types
 *   GET /v1/customers/config/child-seat-types
 *   GET /v1/customers/config/luggage-types
 */

import { customersApiClient } from './apiClient';

const API_ENDPOINTS = {
  PASSENGER_TYPES: '/config/passenger-types',
  CHILD_SEAT_TYPES: '/config/child-seat-types',
  LUGGAGE_TYPES: '/config/luggage-types',
};

export const passengerService = {
  async getPassengerTypes() {
    const result = await customersApiClient.get(API_ENDPOINTS.PASSENGER_TYPES);

    if (result.success) {
      return {
        success: true,
        data: result.data?.passenger_types || [],
        error: null,
      };
    }

    return {
      success: false,
      data: [],
      error: result.error || 'Failed to fetch passenger types',
    };
  },

  async getChildSeatTypes() {
    const result = await customersApiClient.get(API_ENDPOINTS.CHILD_SEAT_TYPES);

    if (result.success) {
      return {
        success: true,
        data: result.data?.child_seat_types || [],
        error: null,
      };
    }

    return {
      success: false,
      data: [],
      error: result.error || 'Failed to fetch child seat types',
    };
  },

  async getLuggageTypes() {
    const result = await customersApiClient.get(API_ENDPOINTS.LUGGAGE_TYPES);

    if (result.success) {
      return {
        success: true,
        data: result.data?.luggage_types || [],
        error: null,
      };
    }

    return {
      success: false,
      data: [],
      error: result.error || 'Failed to fetch luggage types',
    };
  },
};

export default passengerService;
